import React, {useEffect} from 'react';

import * as d3 from 'd3';
import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {isNkRole$} from 'models/auth';
import {ProductOperationsRawRow, ProductTracing} from 'types';

import {build} from './build';
import './styles.css';

interface Props {
    data: {tracing: ProductTracing[]; operations: ProductOperationsRawRow[]} | null;
}

export const TraceGraph = ({data}: Props) => {
    const {t} = useTranslation();
    const isNkRole = useStore(isNkRole$);

    useEffect(() => {
        if (data) build(data, t, !!isNkRole);
        return () => {
            d3.select('#trace-line')
                .selectChildren('*')
                .remove();
            d3.selectAll('.tl-name-tip').remove();
        };
    }, [data, isNkRole, t]);

    return <svg id="trace-line" xmlns="http://www.w3.org/2000/svg" />;
};
